import { BankTab } from '../components/BankTab';

export function BankSection() {
  return <BankTab />;
}
